import { Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { WindowRedirectService } from '@core/services/window-redirect.service';
import { EEventViewMode, TEventFrontendTab } from '@enums/event-tracking.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ICreatorCampaignExport, TCampaignApi } from '@pages/campaigns/campaigns.interface';
import { BriefingNotesDialogComponent } from '@shared/components/briefing-notes-dialog/briefing-notes-dialog.component';
import { IBriefingNotesDialogData } from '@shared/components/briefing-notes-dialog/briefing-notes-dialog.interface';
import { IconComponent } from '@shared/components/icon/icon.component';
import { ICampaignDetailsCreator } from '../../campaign-details.interface';
import { CreatorCampaignExportComponent } from '../../creator-campaign-export/creator-campaign-export.component';

@Component({
  imports: [CreatorCampaignExportComponent, IconComponent, MatButtonModule, MatMenuModule, TranslateModule],
  selector: 'app-creator-actions-menu',
  templateUrl: './creator-actions-menu.component.html',
})
export class CreatorActionsMenuComponent {
  public readonly creator = input.required<ICampaignDetailsCreator>();
  public readonly campaign = input.required<TCampaignApi | null>();
  public readonly creatorCampaignExports = input<Map<string, ICreatorCampaignExport>>(new Map());
  public readonly viewMode = input<EEventViewMode | undefined>(undefined);
  public readonly currentTab = input<TEventFrontendTab | undefined>(undefined);

  public readonly briefingNotesMap = computed(() => {
    return new Map(
      this.campaign()?.briefingNotes?.map((bn) => [
        this.campaign()?.campaignCreators?.find((cc) => cc.creatorId === bn.creatorId)?.creatorId ?? null,
        bn,
      ]) ?? [],
    );
  });

  private readonly dialog = inject(MatDialog);

  public onViewCreator(event: Event, menuTrigger: MatMenuTrigger): void {
    event.stopPropagation();
    menuTrigger.closeMenu();
    WindowRedirectService.openUrlInNewTab(`/creators/${this.creator().id}`);
  }

  public onViewBriefingNotes(event: Event, menuTrigger: MatMenuTrigger): void {
    event.stopPropagation();
    menuTrigger.closeMenu();

    const creator = this.creator();
    const campaignCreator = this.campaign()?.campaignCreators?.find((cc) => cc.creatorId === creator.id);
    const creatorBriefingNote = this.briefingNotesMap().get(campaignCreator?.creatorId ?? '') ?? null;
    const globalBriefingNote = this.briefingNotesMap().get(null) ?? null;
    const briefingNote = creatorBriefingNote ?? globalBriefingNote;

    const data: IBriefingNotesDialogData = {
      briefingNote,
      campaignId: this.campaign()?.id ?? '',
      creatorId: campaignCreator?.creatorId ?? null,
      creatorName: creator.name,
      viewMode: true,
    };

    this.dialog.open(BriefingNotesDialogComponent, {
      data,
      disableClose: true,
      width: '700px',
    });
  }
}
